<template>
  <b-container fluid class="milestone-v2">
    <b-row>
      <b-col class="milestone-title">
        <img
          src="@/assets/rebrand/home/title-milestones.png"
          alt="milestone title"
          class="milestone-title-img img-fluid"
        />
      </b-col>
    </b-row>
    <div class="tiers d-flex flex-column ">
      <MilestoneTier v-for="tier in tiersDesktop" :key="tier.number" :tier="tier" />
    </div>
    <img
      src="@/assets/rebrand/home/milestone-asset-1.png"
      class="milestone-asset-1 d-none d-md-block"
      alt=""
    />
    <img
      src="@/assets/rebrand/home/milestone-asset-1-mobile.png"
      class="milestone-asset-1-mobile d-block d-md-none"
      alt=""
    />
    <img
      src="@/assets/rebrand/home/milestone-asset-2.png"
      class="milestone-asset-2 d-none d-md-block"
      alt=""
    />
    <img
      src="@/assets/mobile/roadmap-overlay.png"
      class="milestone-asset-2-mobile d-block d-md-none"
      alt=""
    />
    <img
      src="@/assets/rebrand/home/milestone-asset-3.png"
      class="milestone-asset-3 d-none d-md-block"
      alt=""
    />
    <img
      src="@/assets/rebrand/home/milestone-asset-4.png"
      class="milestone-asset-4 d-none d-md-block"
      alt=""
    />
    <img src="@/assets/rebrand/home/active-milestone-glow.png" class="milestone-glow-bg" alt="" />
  </b-container>
</template>

<script>
import MilestoneTier from '../../components/MilestoneTier.vue';

export default {
  data() {
    return {
      tiersDesktop: [
        {
          title: 'Pre Sale',
          image: require('@/assets/rebrand/home/pre-sale.svg'),
          status: 'nowminting',
          details: [
            'Debuts 05/17/2022',
            '1x Mint per wallet',
            'FNF 100 Side Kicks',
            'Community 180 Side Kicks',
            'Partner 1000 Side Kicks',
          ],
          active: true,
        },
        {
          title: 'Public Sale',
          image: require('@/assets/rebrand/home/public-sale.svg'),
          status: 'minting',
          details: ['Debuts post Pre Sale', '3x Mint per wallet', '3000 Side Kicks'],
          active: true,
        },
      ],
    };
  },
  components: {
    MilestoneTier,
  },
};
</script>
